import React, { useState, useEffect, useRef } from "react";
import {
    Box,
    Button,
    TextField,
    Typography,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    Card,
    CardContent,
    Divider,
} from "@mui/material";

import { db } from "../../firebase";
import { collection, getDocs, query, where, doc, getDoc } from "firebase/firestore";
import Shopheader from "../Shop/Shopheader";
import Mashalheader from "../Mashal/Mashalheader";
import Wholesalerheader from "../Wholesale/Wholesaleheader";
import { useParams } from "react-router-dom";

function Purchasereport() {
    const { category } = useParams();

    const today = new Date().toISOString().split("T")[0];

    const [fromDate, setFromDate] = useState(today);
    const [toDate, setToDate] = useState(today);
    const [purchaseData, setPurchaseData] = useState([]);
    const [totalGrand, setTotalGrand] = useState(0);
    const [totalPaid, setTotalPaid] = useState(0);
    const [totalRemaining, setTotalRemaining] = useState(0);

    const printRef = useRef();

    // Fetch vendor info by matching dealerId
    const getVendorInfo = async (dealerId) => {

        if (!dealerId) return { name: "-", mobile: "-" };
        const docRef = doc(db, "vendors", dealerId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            const data = docSnap.data();
            return { name: data.name || "-", mobile: data.mobile || "-" };
        }
        return { name: "-", mobile: "-" };


    };

    const getReport = async () => {
        if (!fromDate || !toDate) {
            alert("Please select both dates");
            return;
        }

        try {
            const q = query(
                collection(db, "purchases"),
                where("purchaseDate", ">=", fromDate),
                where("purchaseDate", "<=", toDate),
            );

            const snap = await getDocs(q);
            let data = [];
            let grandTotal = 0;
            let paidTotal = 0;
            let remainingTotal = 0;

            for (const docItem of snap.docs) {
                const d = docItem.data();
                const vendorInfo = await getVendorInfo(d.dealerId); // <-- match dealerId

                data.push({
                    id: docItem.id,
                    ...d,
                    vendorName: vendorInfo.name,
                    vendorMobile: vendorInfo.mobile,
                });

                grandTotal += parseFloat(d.grandTotal || 0);
                paidTotal += parseFloat(d.paidAmount || 0);
                remainingTotal += parseFloat(d.remaining || 0);
            }

            setPurchaseData(data);
            setTotalGrand(grandTotal);
            setTotalPaid(paidTotal);
            setTotalRemaining(remainingTotal);
        } catch (err) {
            console.error("Error fetching खरेदी रिपोर्ट :", err);
        }
    };

    const handlePrint = () => {
        const content = printRef.current.innerHTML;
        const printWindow = window.open("", "_blank");
        printWindow.document.write(`
      <html>
        <head>
          <title>खरेदी रिपोर्ट </title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            table { width: 100%; border-collapse: collapse; margin-top: 10px; }
            th, td { border: 1px solid #000; padding: 8px; text-align: left; }
            th { background-color: #1976d2; color: #fff; }
            h2,h4 { margin: 5px 0; }
          </style>
        </head>
        <body>
          ${content}
        </body>
      </html>
    `);
        printWindow.document.close();
        printWindow.print();
    };

    useEffect(() => {
        getReport();
    }, []);

    return (
        <Box p={3} mt={10}>
            {category === "shop" && <Shopheader />}
            {category === "mashal" && <Mashalheader />}
            {category === "wholesaler" && <Wholesalerheader />}

            <Card elevation={6} sx={{ borderRadius: 3, p: 2 }}>
                <CardContent>
                    <Typography variant="h5" fontWeight="bold" gutterBottom>
                        खरेदी रिपोर्ट 
                    </Typography>
                    <Divider sx={{ mb: 3 }} />

                    {/* Date Filters */}
                    <Box display="flex" gap={2} mb={3} flexWrap="wrap">
                        <TextField
                            label="या तारखेपासून "
                            type="date"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                            sx={{ minWidth: 200 }}
                        />
                        <TextField
                            label="या तारखेपर्यंत "
                            type="date"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                            sx={{ minWidth: 200 }}
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={getReport}
                            sx={{ minWidth: 150 }}
                        >
                            Get Report
                        </Button>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={handlePrint}
                            sx={{ minWidth: 150 }}
                        >
                            Print
                        </Button>
                    </Box>

                    <Box ref={printRef}>
                        <Box textAlign="center" mb={2}>
                            <Typography variant="subtitle1">
                                खरेदी रिपोर्ट  from {fromDate} to {toDate}
                            </Typography>
                        </Box>

                        {purchaseData.length > 0 ? (
                            <Paper elevation={3} sx={{ borderRadius: 2, overflow: "hidden", mb: 2, overflowX:"auto"  }}>
                                <Table>
                                    <TableHead sx={{ backgroundColor: "#1976d2" }}>
                                        <TableRow>
                                            <TableCell sx={{ color: "#fff" }}><b>Sr No</b></TableCell>
                                            <TableCell sx={{ color: "#fff" }}><b>विक्रेता </b></TableCell>
                                            <TableCell sx={{ color: "#fff" }}><b>मोबाईल</b></TableCell>
                                            <TableCell sx={{ color: "#fff" }}><b>दिनांक</b></TableCell>
                                            <TableCell sx={{ color: "#fff" }}><b>ग्रँड टोटल </b></TableCell>
                                            <TableCell sx={{ color: "#fff" }}><b>जमा </b></TableCell>
                                            <TableCell sx={{ color: "#fff" }}><b>बाकी </b></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {purchaseData.map((purchase, index) => (
                                            <TableRow key={purchase.id}>
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell>{purchase.vendorName}</TableCell>
                                                <TableCell>{purchase.vendorMobile}</TableCell>
                                                <TableCell>{purchase.purchaseDate}</TableCell>
                                                <TableCell>₹{parseFloat(purchase.grandTotal || 0).toFixed(2)}</TableCell>
                                                <TableCell>₹{parseFloat(purchase.paidAmount || 0).toFixed(2)}</TableCell>
                                                <TableCell>₹{parseFloat(purchase.remaining || 0).toFixed(2)}</TableCell>
                                            </TableRow>
                                        ))}

                                        <TableRow sx={{ backgroundColor: "rgba(25,118,210,0.1)" }}>
                                            <TableCell colSpan={4} align="right"><b>Total</b></TableCell>
                                            <TableCell><b>₹{totalGrand.toFixed(2)}</b></TableCell>
                                            <TableCell><b>₹{totalPaid.toFixed(2)}</b></TableCell>
                                            <TableCell><b>₹{totalRemaining.toFixed(2)}</b></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </Paper>
                        ) : (
                            <Typography mt={2} color="textSecondary" align="center">
                                No purchase data found for the selected date range.
                            </Typography>
                        )}
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
}

export default Purchasereport;
